import { type FC } from 'react'
import { FormattedMessage } from 'react-intl'

import { ErxBonusLandingPageFaqAccordion } from './ErxBonusLandingPageFaqAccordion'
import { ErxBonusLandingPageFaqHowToCard } from './ErxBonusLandingPageFaqHowToCard'

export const ErxBonusLandingPageFaq: FC = () => {
  return (
    <div className="py-10" itemScope itemType="https://schema.org/FAQPage">
      <div className="px-10 text-center text-2xl tablet:px-0">
        <FormattedMessage id="deErx.oldBonus.landingPageFaq.title" />
      </div>
      <div className="mt-12 flex flex-col gap-8 tablet:flex-row tablet:px-0">
        <div className="w-full flex-1 basis-2/3">
          <ErxBonusLandingPageFaqAccordion />
        </div>
        <div className="basis-1/3">
          <ErxBonusLandingPageFaqHowToCard />
        </div>
      </div>
    </div>
  )
}
